import type { ArchitecturalAnalysis } from '@paint-ai/shared';
import { Building, CheckCircle, Sparkles, Wrench } from 'lucide-react';
import type { ReactNode } from 'react';
import { Badge, Card } from '@/components/ui';

function Fact({ label, children }: { label: ReactNode; children: ReactNode }) {
  return (
    <div className="bg-slate-50 p-3.5 rounded-xl border border-slate-200 space-y-1">
      <span className="text-[10px] font-bold uppercase text-slate-400 flex items-center gap-1">{label}</span>
      {children}
    </div>
  );
}

const list = (items: string[], fallback: string) => (items.length > 0 ? items.join(', ') : fallback);

export function ArchitecturalAnalysisCard({ analysis }: { analysis: ArchitecturalAnalysis }) {
  return (
    <Card>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Building className="w-5 h-5 text-blue-600" />
          <h2 className="text-base font-bold text-slate-800">Architectural Structural Analysis</h2>
        </div>
        <div className="flex items-center gap-2">
          <Badge tone="sky" className="rounded">
            gemini-3.7-flash
          </Badge>
          <span className="text-[10px] px-2.5 py-1 rounded-full bg-blue-50 text-blue-700 border border-blue-200 font-bold uppercase tracking-wider flex items-center gap-1">
            <Sparkles className="w-3.5 h-3.5 text-blue-600" /> ANALYZED
          </span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-xs">
        <Fact label="Architectural Style">
          <p className="text-sm font-bold text-blue-700">{analysis.styleName || 'Modern Indian Elevation'}</p>
        </Fact>
        <Fact
          label={
            <>
              <Wrench className="w-3 h-3 text-blue-600" /> Cleaned Elements
            </>
          }
        >
          <p className="text-slate-700 font-medium">
            {list(analysis.detectedDefects, 'Scaffolding, Cables, Raw Masonry, Debris')}
          </p>
        </Fact>
        <Fact
          label={
            <>
              <CheckCircle className="w-3 h-3 text-emerald-600" /> Synthesized Features
            </>
          }
        >
          <p className="text-slate-700 font-medium">
            {list(analysis.suggestedEnhancements, 'Glass Windows, Steel Gate, Landscaping')}
          </p>
        </Fact>
      </div>
    </Card>
  );
}
